// extracted by mini-css-extract-plugin
export var fadeInOut = "_2c-3";
export var icon = "_2c-4";
export var savedIndicator = "_2c-2";
export var savingIndicator = "_2c-0";
export var spin = "_2c-1";